import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const QUERY = gql`
  query projectCurrencies($id: Int!) {
    project(id: $id) {
      id
      currencies
    }
  }
`;

const useProjectCurrencies = ({ projectId }) => {
  const { loading, data } = useQuery(QUERY, {
    skip: !projectId,
    variables: { id: parseInt(projectId) },
  });
  return { loading, data: data?.project.currencies };
};

export default useProjectCurrencies;
